// extracted by mini-css-extract-plugin
export default {"content":"Index_content__VvodX","content__video":"Index_content__video__71Hq1","managers":"Index_managers__WFwAv","hidden":"Index_hidden__OaaL6"};